import React from 'react';

export default function Component(props) {

  const { question, answersList, ansTextBoxChange1 } = props;

  return (
    <>
      <div className='2xl:w-4/5 xl:w-1/2 lg:w-11/12'>
        <input
          type="number"
          value={(answersList && answersList.length > 0 && answersList
            .findIndex(item => item.questionId === question.id) !== -1) ?
            answersList[answersList.findIndex(item => item.questionId === question.id)].answer1
            : ''}
          onChange={(event) => ansTextBoxChange1(event, question)}
          className="w-full bg-white rounded-md mt-4 p-3 text-sm text-[#212121] placeholder-[#212121]/70 border border-[#212121]"
          placeholder={"Number.."} />

      </div>
    </>
  );
}